module.exports = __webpack_public_path__ + "static/img/par3.8aa223b0.png";